import {ReactElement} from "react";

interface ImmoKeyFactsBadgePropsInterface {
	icon: ReactElement;
	count: number;
}

export default function ImmoKeyFactsBadge(
	props: ImmoKeyFactsBadgePropsInterface
) {
	return (
		<div className="text-leo-button-gray relative">
			<div className="h-5 w-5 sm:h-7 sm:w-7 pt-2 pr-2">{props.icon}</div>
			<div className="rounded-full bg-leo-button-gray text-white text-center text-[0.5rem] sm:text-xs w-3 h-3 sm:w-4 sm:h-4 top-0 absolute right-0 leading-normal">
				{props.count}
			</div>
		</div>
	);
}
